import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { TrackManager } from "@x-mile/api-contract";
import type { GetVehiclesParams } from "../model";

export const useGetVehicles = (
  params: GetVehiclesParams,
  options?: QueryOptions<typeof TrackManager.useGetVehicles>,
): UseQueryResult<TrackManager.GetVehiclesQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getVehicles", keysToSnakeCase(params)],
    queryFn: () =>
      TrackManager.getVehicles(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    TrackManager.GetVehiclesQueryResult,
    undefined
  >;
};

export const useMultipleGetVehicles = (
  paramsList: { [key: string | number]: GetVehiclesParams },
  options?: QueryOptions<typeof TrackManager.useGetVehicles> & {
    sortFunc?: (a: GetVehiclesParams, b: GetVehiclesParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    TrackManager.GetVehiclesQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getVehicles", keysToSnakeCase(params)],
        queryFn: () =>
          TrackManager.getVehicles(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      TrackManager.GetVehiclesQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetVehiclesMock = (
//   params: GetVehiclesParams,
//   options?: QueryOptions<typeof TrackManager.useGetVehicles>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetVehiclesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetVehicles(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetVehiclesMock = (
//   paramsList: { [key: string | number]: GetVehiclesParams },
//   options?: QueryOptions<typeof TrackManager.useGetVehicles>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetVehiclesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetVehicles(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
